const ViewValidate = () => import('./Validate')

const router = [
  {
    path: '/',
    name: 'Init',
    component: ViewValidate,
  },
]

export default router
